import AsyncView from 'shopify-asyncview';
import morphdom from 'morphdom';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import CartItem from './CartItem';

class MonoCart {
  constructor() {
    this.carts = [];
  }

  addCart(el) {
    const cartItemEls = el.querySelectorAll('[data-cart-item]');
    const cartItems = [];

    cartItemEls.forEach(cartItemEl => cartItems.push(new CartItem(cartItemEl, this.update.bind(this))));

    this.carts.push({
      el,
      cartItems,
    });
  }

  update() {
    return AsyncView.load(
      '/cart',
      'ajax',
    ).done((data) => {
      this.carts.forEach((cart) => {
        cart.cartItems.forEach(cartItem => cartItem.unload());
        cart.cartItems = [];

        const cartElements = [
          {
            containers: cart.el.querySelectorAll('[data-cart-items]'),
            html: data.html.cart_items,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-discounts]'),
            html: data.html.cart_discounts,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-discounts-simplified]'),
            html: data.html.cart_discounts_simplified,
          },
          {
            containers: cart.el.querySelectorAll('[data-cart-subtotal]'),
            html: data.html.cart_subtotal,
          },
        ];

        cartElements.forEach(({ containers, html }) => {
          for (let i = 0; i < containers.length; i++) {
            const container = containers[i];
            const virtualContainer = document.createElement('div');

            virtualContainer.innerHTML = html;

            morphdom(
              container,
              virtualContainer,
              {
                childrenOnly: true,
                onBeforeElUpdated: (fromEl, toEl) => {
                  // Skip images if src matches
                  // - we don't want to reload lazy loaded images
                  if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
                    return false;
                  }

                  return true;
                },
              },
            );

            const cartMoneyEls = container.querySelectorAll('.money');
            cartMoneyEls.forEach(cartMoneyEl => CurrencyConverter.update(cartMoneyEl));

            if (container.classList.contains('money')) {
              CurrencyConverter.update(container);
            }

            const cartItemEls = container.querySelectorAll('[data-cart-item]');
            cartItemEls.forEach(cartItemEl => cart.cartItems.push(new CartItem(cartItemEl, this.update.bind(this))));

            rimg.watch(container);
          }
        });

        return data;
      });
    });
  }

  unload() {
    this.carts.forEach((cart) => {
      cart.cartItems.forEach(cartItem => cartItem.unload());
    });
    this.carts = [];
  }
}

export default new MonoCart();
